import { PageHeaderWrapper, Title } from "@clipboard-health/ui-components";

import { PageHeaderTopRow, type PageHeaderTopRowProps } from "../components/PageHeaderTopRow";

interface OnboardingHeaderProps
  extends Pick<PageHeaderTopRowProps, "fallbackGoBackPath" | "onClickBack"> {
  title: string;
  compact?: boolean;
}

export function OnboardingHeader(props: OnboardingHeaderProps) {
  const { fallbackGoBackPath, onClickBack, title, compact } = props;

  return (
    <PageHeaderWrapper variant="tertiary">
      {/* TODO: This will show a progress bar later on  as a title when we revamp onboarding */}
      <PageHeaderTopRow fallbackGoBackPath={fallbackGoBackPath} onClickBack={onClickBack} />

      <Title
        variant={compact ? "h6" : "h3"}
        component="h1"
        sx={{
          textAlign: "center",
          textWrap: "balance",
          paddingX: 7,
          paddingBottom: 8,
          display: compact ? "none" : undefined,
        }}
      >
        {title}
      </Title>
    </PageHeaderWrapper>
  );
}
